<template>
  <div id="app">
    <!-- <div class="tab-bar">
      <router-link to="/agreement" class="default" active-class="active">协议</router-link>
      <router-link to="/privacy" class="default" active-class="active">隐私</router-link>
    </div> -->
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>
.app {
  margin: 0;
  padding: 0;
}
.tab-bar {
  text-align: center;
  margin-bottom: 15px;
}
.default {
  color: black;
}
.active {
  color: darkcyan;
}
</style>



// WEBPACK FOOTER //
// src/App.vue